import { EntityTypes } from '../enums';

export class CustomerSearchResult {
    ID: string;
    EntityID: number;
    EntityTypeID: EntityTypes;
    Name:string;
    Address:string;
    BirthDate:string;
    Status:string;
    ImgStatusPath:string;
    ImageID?: number;
    ImagePath; string;
    Gender: string;
    IsConfidential:boolean;
    Label1:string;
    Label2:string;
    Label3:string;
    ParentID?: number;
    ParentName:string;
    IDNumber: string;
    Age:string;    
    Phone:string;
    Phone2:string;
    Email: string;
    Active: boolean;
    IsBlocked: boolean;

    constructor(obj?: any){
        this.ID = obj && obj.ID || null; // when the first operand is true AND return the second operand
        this.EntityID = obj && obj.EntityID || null;        
        this.EntityTypeID = obj && obj.EntityTypeID || null;
        this.Name = obj && obj.Name || null;
        this.Address = obj && obj.Address || null;
        this.BirthDate = obj && obj.BirthDate || null;
        this.Status = obj && obj.Status || null;
        this.ImgStatusPath = obj && obj.ImgStatusPath || null;
        this.ImageID = obj && obj.ImageID || null;
        this.ImagePath = obj && obj.ImagePath || null;
        this.Gender = obj && obj.Gender || null;
        this.IsConfidential = obj && obj.IsConfidential || true;
        this.Label1 = obj && obj.Label1 || null;
        this.Label2 = obj && obj.Label2 || null;
        this.Label3 = obj && obj.Label3 || null;
        this.ParentID = obj && obj.ParentID || null;
        this.ParentName = obj && obj.ParentName || null;
        this.IDNumber = obj && obj.IDNumber || null;
        this.Age = obj && obj.Age || null;
        this.Phone = obj && obj.Phone || null;
        this.Phone2 = obj && obj.Phone2 || null;

        
        this.Email = obj && obj.Email || null;
        this.Active = obj && obj.Active || false;
        this.IsBlocked = obj && obj.IsBlocked || false;
    }

}
